export const CONSTANTS = {
    NEST_BACKEND_URL: "/api2/graphql",
    SAILS_BACKEND_URL: "/api",
    INITIATIVES_WITHOUT_PACKAGE_TITLE: "My Initiatives",
}